import type { UseQueryResult } from '@tanstack/react-query'

import { LoadingButton } from '@fortem-monorepo/react-ui'
import { getErrorMessage } from '@fortem-monorepo/web-sdk'

export const StrategyOptionsFeedback = ({ query, label }: { query: UseQueryResult; label: string }) => (
  <>
    {query.isPending && <p role="status">Loading {label}…</p>}
    {query.isError && (
      <div role="alert" className="text-destructive text-sm">
        Unable to load {label}. {getErrorMessage(query.error)}
        <LoadingButton size="sm" variant="outline" disabled={query.isFetching} onClick={() => query.refetch()}>
          Retry
        </LoadingButton>
      </div>
    )}
  </>
)
